<template>
    <div class="flex items-center gap-2">
        <Icon
            name="calendar"
            class="w-3.5 h-3.5 text-gray-500"
            :class="{ invisible: hideIcon }"
        />
        <span>
            {{ content }}
        </span>
    </div>
</template>

<script setup lang="ts">
    import Icon from '@/Shared/Component/Icon.vue'

    const props = defineProps({
        content: {
            type: String,
            required: true,
        },
        hideIcon: {
            type: Boolean,
            required: true,
        },
    })
</script>
